<template>
    <el-checkbox-group class="z-list" v-model="ids" @change="emitCheck">
        <!--表头-->
        <div class="head">
            <div>{{ title_name }}</div>
            <div>任务编号</div>
            <div v-if="keyStatus == 10">创建时间</div>
            <div v-else>发布时间</div>
            <div>任务名称</div>
            <!-- <div class="more" @click="typeflag=true" @mouseout="hideType()"> -->
            <div class="more" >
                任务类型
                <span class="change"></span>
                <typeChoose class="show" :length="taskTpl.length+1">
                    <div @click.stop="selectType('','全部类型',$event)" class="active">全部</div>
                    <div v-for="(type,index) in taskTpl" :key="type.id" @click.stop="selectType(type.id,type.tpl_name,$event)" class="overhide" :title="type.tpl_name">{{ type.tpl_name }}</div>
                </typeChoose>
            </div>
            <div>任务奖金({{ task_curr.currency_name }})</div>
            <div>周期(天)</div>
            <!-- <div class="more" @click="stateflag=true" @mouseout="hideState()"> -->
            <div class="more">
                状态
                <span class="change"></span>
                 <typeChoose class="show" :length="Object.keys(status_obj).length+1">
                    <div @click.stop="selectState('','全部状态',$event)" class="active">全部</div>
                    <div v-for="(text,key) in status_obj" :key="text" @click.stop="selectState(key,text,$event)">{{ text }}</div>
                </typeChoose>
            </div>
            <div>操作</div>
        </div>
    
        <!--列表-->
        <z-scrollDiv class="list-wrap">
            <a class="list-item" :class="{highlight:high_id == item.id}" :key="item.id" v-for="item in dataList" >
                <el-checkbox v-if="keyStatus == 10" :label="item.id" :disabled="item.category_status==10 && item.process_status ==102">{{ "" }}</el-checkbox>
                <div>{{ user_type == 1 ?item.sub_bu_name:item.pub_bu_name }}
                    <!-- <img class="avatar" :src="setImg(item)" alt="用户头像" @mouseover="activeIndex=index" @mouseout="activeIndex=''"> -->
                    <!-- <transition name="fade">
                        <div class="tipBox" v-show="activeIndex === index">
                            {{ makename() }}
                            <p>{{ maketip(item) }}</p>
                        </div>
                    </transition> -->
                </div>
                <div>{{ item.code }}</div>
                <div v-if="keyStatus == 10" class="item-time">
                    {{ item.created_at | justDate }}
                    <div class="tipTime">
                        {{ item.created_at }}
                    </div>
                </div>
                <div v-else class="item-time">
                    {{ item.release_time | justDate }}
                    <div class="tipTime">
                        {{ item.release_time }}
                    </div>
                </div>
                <div>
                    <span class="mid">{{ item.task_name }}</span>
                </div>
                <div>{{ item.tpl_name }}</div>
                <div>{{ item.currency_amount }}</div>
                <div>{{ item.task_cycle }}</div>
                <div>{{ status_obj[item.process_status] }}<span v-html="restDays(item)"></span></div>
                <div @click="link(item.id)" :class="{'orange-text':btnJudge(item)}">{{ dealText(item) }}</div>
            </a>
            <z-noData :list="dataList"></z-noData>
        </z-scrollDiv>
    
    </el-checkbox-group>
</template>

<script>
import typeChoose from "src/components/type-choose.vue"
import { mapState,mapGetters } from "vuex"

export default {
    props: ["keyStatus","data","config","idStr"],
    components:{
        typeChoose,
    },
    data() {
        return {
            activeIndex: "",   //头像浮窗的弹出序号
            typeflag: false,   //任务类型列表出现判断
            stateflag: false,  //任务状态列表出现判断

            ids:[],  //删除的任务id合集
            color_judge:[],  //颜色控制数组
        }
    },
    computed: {
        ...mapState(["userInfo","taskTpl"]),
        ...mapState({
            status_obj:function(state){
                return state.task.task_status[this.keyStatus][this.user_type];
            },
            high_id: state => state.task.highlight_id,
        }),
        ...mapGetters(['task_curr']),
        user_type(){
            return this.config.source_type || 1;  // 1：发布方  2：接收方  3：管理员
        },
        title_name() {  //标题文字
            return this.user_type == 1 ? "接收BU" : "发布BU";
        },
        dataList() {
            return this.data.list || [];
        },
    },

    filters:{

    },

    watch: {
        idStr(str) {
            this.ids = str?str.split(",").map(val=>parseInt(val)):[];
        },
        // seachKeyWord(val) {
        //     this.config.keyword = val;
        //     this.config.page = 1;
        //     this.chooseData();
        // },

    },

    created() {
        this.$func.getTaskTpl();  //拉取任务类型
        this.$func.getUserInfo();  //拉取用户信息
    },

    methods: {
        chooseData() {  // 请求list数据
            this.$emit('refresh');
            // let config = { params: { ...this.config } }
            // this.$http.get(this.url, config).then(res => {
                
            // });
        },
        emitCheck(){  //修改多选 
            this.$emit("choose",[...this.ids]);
        },
        link(id) {   //跳转到详情页面
            let id_text = this.$crypto.encrypt(id);

            this.$router.push({
                name: `task-detail`,
                params: {
                    task_id: id_text,
                }
            });
        },
        btnJudge(item){  //是否有流程按钮需要操作
            let text;
            let status = item.category_status;
            let process= item.process_status;

            switch (this.user_type) {
                case 1:  //发布方
                    let arr = [
                        status == 10 && process != 102,
                        status == 20 && process == 202,
                        status == 20 && process == 204,
                        status == 20 && process == 205,
                    ];
                    if(arr.some(val=>val)){
                        return true;
                    }else{
                        return false;
                    }
            
                case 2:  //接收方
                    let arr2 = [
                        status == 20 && process == 201,
                        status == 20 && process == 203,
                    ];
                    if(arr2.some(val=>val)){
                        return true;
                    }else{
                        return false;
                    }
            }
        },
        dealText(item){  //构造操作文本
            return this.btnJudge(item)?"处理":"详情";
        },
        // ***状态栏/类型栏

        hideType(e) {  //隐藏任务类型选框
            if (!this.typeflag) {
                return;
            }
            e = e || window.event;
            let tar = e.toElement || e.relatedTarget;
            if (tar.parentNode.className != "show" && tar.parentNode.className != "more" && e.target.tagName != "SPAN") {
                this.typeflag = false;
                return;
            }
        },
        hideState(e) { //隐藏任务状态选框
            if (!this.stateflag) {
                return;
            }
            e = e || window.event;
            let tar = e.toElement || e.relatedTarget;
            if (tar.parentNode.className != "show" && tar.parentNode.className != "more" && e.target.tagName != "SPAN") {
                this.stateflag = false;
                return;
            }
        },


        addactive(tar) {
            let siblings = tar.parentNode.childNodes;
            for (let i = 0, len = siblings.length; i < len; i++) {
                siblings[i].className = "";
            }
            tar.className = "active";
        },
        selectType: function (id, name, e) {
            this.typeflag = false; //隐藏任务类型
            e = e || window.event;
            this.addactive(e.target);
            this.config.template_id = id;
            this.chooseData();

        },
        selectState: function (key, name, e) {
            this.stateflag = false; //隐藏状态列表
            e = e || window.event;
            this.addactive(e.target);
            // this.config[this.keyStr + "_status"] = id;
            this.config.process_status = key;
            this.chooseData();
        },

        // *** 剩余天数渲染
        restDays(item){
            let status = item.days_status;
            let category_status = item.category_status;
            let days = item.days;

            if(category_status !== 20){
                return "";
            }

            let class_name = 'day-text';
            if(days<= 2){
                class_name = 'day-text-danger'
            }else if(days>2 && days<=5){
                class_name = 'day-text-warn'
            }

            switch (status) {
                case -1:
                    return "";
                case 0:
                    return days<=0?`（<i class="day-text-danger">滞留</i>）`:`（<i class="${class_name}">剩余${days}天</i>）`;
                case 10:
                    return `（<i class="${class_name}">剩余${days}天</i>）`;
                case 20:
                    return `（<i class="day-text-danger">延期${days}天</i>）`;
                case 30:
                    return `（<i class="day-text-danger">已违约</i>）`;
            }
        },
    }
}

</script>


<style lang="less">
@import "~src/assets/less/task.less";
.day-text{
    // font-weight: 600;
    color:#22AB15;
    font-style: normal;
}
.day-text-warn{
    // font-weight: 600;
    font-style: normal;
    color:#EE7C00;
}
.day-text-danger{
    // font-weight: 600;
    font-style: normal;
    color:#F80505;
}
</style>



// WEBPACK FOOTER //
// tasklistTpl.vue?e44ef576